(async () => {
  await Office.onReady();
  document.getElementById("ok-button").onclick = sendOKToParentPage;
  function sendOKToParentPage() {
    Office.context.ui.messageParent("OK");
  }
  document.getElementById("cancel-button").onclick = sendCancelToParentPage;
  function sendCancelToParentPage() {
    Office.context.ui.messageParent("CANCEL");
  }
})();
